import { ImageDataLike } from "gatsby-plugin-image";
import { IContentfulRichTextResponse } from "./IContentfulRichText";
import { IContentfulImage } from "./IContentfulImage";
import { ICTA } from "./ICTA";
import { IHeroLink } from "./IHeroLink";
import { IContentfulLink } from "./IContentfulLink";

export type HeroSize = "regular" | "short";

export enum HeroVersion {
  V1 = "v1",
  V3 = "v3",
  V4 = "v4",
  V5 = "v5",
  V6 = "v6",
  HeroSmartBuyer = "HeroSmartBuyer",
  HeroSimpleBetterV2 = "HeroSimpleBetterV2",
  HeroMIP = "HeroMIP",
  HeroGreenWithGlossyText = "HeroGreenWithGlossyText",
  HeroChecklist = "HeroChecklist",
  HeroMobileDownload = "HeroMobileDownload",
  FF2 = "ff2",
}

interface ILink {
  url: string;
  text: string;
}

interface IHeroPropsBase {
  size?: HeroSize;
  image?: IContentfulImage & ImageDataLike;
  imageFullWidth?: IContentfulImage & ImageDataLike;
  imageMobile?: IContentfulImage & ImageDataLike;
  firstCta?: ICTA;
  secondCta?: ICTA;
  partner?: string
  heroLink?: IHeroLink;
  smallImage?: IContentfulImage;
  navButton1?: ICTA;
  navButton2?: ICTA;
  navButton3?: ICTA;
  navButton4?: ICTA;
  trustPilot?: IContentfulImage;
  heroVersion?: HeroVersion;
  trustpilotIconLink?: IContentfulLink;
  inlineImage2?: IContentfulImage;
  inlineImage2Mobile?: IContentfulImage;
  inlineImage2Link?: IContentfulLink;
  showLendersAndMortgages?: boolean;
  lendersAndMortgagesLink?: IContentfulLink;
  colourPreset?: "white" | "dark-green" | "green" | "light-green" | "yellow";
  callToActions?: ICTA[];
  optionLinks?: ILink[];
  variant?: "orange" | "green";
  bullets?: string[];
  bulletsTitle?: string;
  showLogo?: boolean;
}

export interface IContentfulHeroProps extends IHeroPropsBase {
  disclaimerText?: IContentfulRichTextResponse;
  heading1?: IContentfulRichTextResponse;
  heading2?: IContentfulRichTextResponse;
}
